import { styled, Box } from '@mui/material'

const StyledBox = styled(Box)(({ theme }) => ({
  '& fieldset.MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.73)'
  },
  display: 'flex',
  '& .MuiButton-root': {
    // border: '1px solid red',
    width: 'max-content',
    backgroundColor: theme.palette.leitura.main,
    margin: '0 0.3rem'
  },
  [theme.breakpoints.down('md')]: {
    display: 'block',
    justifyContent: 'center',
    width: '100%',
    '& .filterButton': {
      // backgroundColor: 'rgb(255, 125, 0)',
      marginTop: '0.5rem'
    },
    '& .MuiButton-root': {
      margin: '0',
      marginTop: '0.5rem',
      // border: '1px solid white',
      width: '100%'
    },
    '& .MuiTextField-root': {
      width: '100%'
    }
  }
}))
export default StyledBox
